export enum EItemTypes {
  SIZE = 'size',
  QUANTITY = 'quantity',
  OFF = 'off',
}
export const SIZES = ['Light', 'Regular', 'Extra'];
